/* A GAVETA DO CARRINHO — Éttore
 *
 * O desenho vem do rascunhos/carrinho.html; a marcação, do
 * sections/ettore-gaveta.liquid. Aqui mora o comportamento.
 *
 * ⚠️ POR QUE ESTE ARQUIVO É UM ASSET E NÃO UM <script> DENTRO DA SEÇÃO:
 *   a gaveta se redesenha pela Section Rendering API a cada mudança do
 *   carrinho. Se o script morasse dentro da seção, cada redesenho o
 *   executaria de novo — e a segunda chamada de customElements.define
 *   lança erro, matando tudo que vem depois, calado.
 *
 * ⚠️ TODO CLIQUE É POR DELEGAÇÃO, num listener só na raiz. É o que permite
 *   trocar o miolo inteiro por HTML novo sem religar nada.
 *
 * ⚠️ UMA CHAMADA POR VEZ. Dois "+" em sequência mandariam duas quantidades
 *   diferentes, e venceria a última a responder — que pode ser a primeira a
 *   ter saído. É assim que carrinho soma errado, e é o momento em que a
 *   pessoa paga.
 */
(function () {
  if (customElements.get('cart-drawer')) return;

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function br(centavos) {
    return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* ═══ FRETE E PRAZO PELA TABELA "FRETE FIXO" DA YAMPI — [2026-09-30] ═══════
     Regra dele: *"a gente oferece o frete fixo no frete econômico… não tem que
     pensar isso aí"*. Vale SÓ a tabela Frete Fixo (Yampi 1749476), a mesma que o
     checkout usa: 58 faixas de CEP, preço e prazo NÃO dependem do peso.
     Cada linha: [CEP/1000 mínimo, CEP/1000 máximo, preço em centavos, dias úteis].
     Fonte: `documentos/frete-yampi/1749476.jsonl` (todas as faixas começam em
     …000 e terminam em …999, por isso cabem em 5 dígitos).
     📏 O preço bate 100% com a regra antiga (9,90 Sul/Sudeste, 19,90 o resto);
       o que muda é o PRAZO: era "3 a 7" para todos, e Salvador leva 9, Manaus 24.
     🪤 A tabela tem 5 buracos (ex.: 10000–10999, 78900–78999). CEP ali NÃO é
       "não existe": é "o checkout calcula". Nunca inventar número para ele.
     🪤 GO: 73700–74000 (interior 2) e 74000–74899 (capital) se sobrepõem em
       74000; as duas dão 19,90 / 9 dias, então tanto faz qual casa primeiro.
     A página de produto (`ettore-frete.js`) lê daqui — tabela num lugar só. */
  var FRETE_FIXO = [[1000,9999,990,6],[11000,19999,990,8],[20000,26600,990,7],[26601,28999,990,9],[29000,29099,990,5],[29100,29999,990,8],[30000,31999,990,3],[32000,39999,990,9],[40000,44470,1990,9],[44471,48999,1990,12],[49000,49099,1990,9],[49100,49999,1990,12],[50000,54999,1990,10],[55000,56999,1990,13],[57000,57099,1990,10],[57100,57999,1990,12],[58000,58099,1990,11],[58100,58999,1990,12],[59000,59099,1990,10],[59100,59999,1990,12],[60000,61900,1990,11],[61901,63999,1990,12],[64000,64099,1990,14],[64100,64999,1990,15],[65000,65109,1990,15],[65110,65999,1990,17],[66000,66999,1990,12],[67000,68899,1990,18],[68900,68914,1990,17],[68915,68999,1990,20],[69000,69099,1990,24],[69100,69299,1990,34],[69300,69339,1990,24],[69340,69389,1990,29],[69400,69899,1990,34],[69900,69920,1990,16],[69921,69999,1990,17],[70000,70999,1990,5],[71000,72799,1990,5],[72800,72999,1990,9],[73000,73699,1990,5],[73700,74000,1990,9],[74000,74899,1990,9],[74900,76799,1990,9],[76800,76833,1990,15],[76834,76999,1990,15],[77000,77270,1990,11],[77300,77995,1990,15],[78000,78109,1990,9],[78110,78899,1990,11],[79000,79124,1990,8],[79125,79999,1990,11],[80000,83800,990,6],[83801,87999,990,10],[88000,88469,990,7],[88470,89999,990,10],[90000,94900,990,7],[94901,99999,990,9]];

  /* só para a UF quando o ViaCEP não responde */
  var FAIXAS = [
    [1000000, 19999999, 'SP'], [20000000, 28999999, 'RJ'], [29000000, 29999999, 'ES'],
    [30000000, 39999999, 'MG'], [40000000, 48999999, 'BA'], [49000000, 49999999, 'SE'],
    [50000000, 56999999, 'PE'], [57000000, 57999999, 'AL'], [58000000, 58999999, 'PB'],
    [59000000, 59999999, 'RN'], [60000000, 63999999, 'CE'], [64000000, 64999999, 'PI'],
    [65000000, 65999999, 'MA'], [66000000, 68899999, 'PA'], [68900000, 68999999, 'AP'],
    [69000000, 69299999, 'AM'], [69300000, 69399999, 'RR'], [69400000, 69899999, 'AM'],
    [69900000, 69999999, 'AC'], [70000000, 73699999, 'DF'], [73700000, 76799999, 'GO'],
    [76800000, 76999999, 'RO'], [77000000, 77999999, 'TO'], [78000000, 78899999, 'MT'],
    [79000000, 79999999, 'MS'], [80000000, 87999999, 'PR'], [88000000, 89999999, 'SC'],
    [90000000, 99999999, 'RS']
  ];

  function uf(cep) {
    var n = parseInt(String(cep).replace(/\D/g, ''), 10);
    if (isNaN(n)) return null;
    for (var i = 0; i < FAIXAS.length; i++) {
      if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
    }
    return null;
  }

  function faixa(cep) {
    var n = Math.floor(parseInt(String(cep).replace(/\D/g, ''), 10) / 1000);
    for (var i = 0; i < FRETE_FIXO.length; i++) {
      if (n >= FRETE_FIXO[i][0] && n <= FRETE_FIXO[i][1]) return { preco: FRETE_FIXO[i][2], dias: FRETE_FIXO[i][3] };
    }
    return null;
  }

  /* Destino de um CEP: { cep, cidade, uf, preco, dias } — `preco`/`dias` nulos
     quando o CEP cai num buraco da tabela; `erro` quando o ViaCEP diz que o CEP
     não existe. Cidade pelo ViaCEP, como fazia o `calculador-frete` do tema
     antigo; se ele falhar ou demorar 4 s, segue só com a UF (a faixa de CEP já
     basta para preço e prazo — a cidade é só para a pessoa conferir). */
  function destino(cep) {
    cep = String(cep).replace(/\D/g, '');
    var f = faixa(cep);
    var d = { cep: cep, cidade: '', uf: uf(cep) || '', preco: f ? f.preco : null, dias: f ? f.dias : null };
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, 4000);
    return fetch('https://viacep.com.br/ws/' + cep + '/json/', ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.erro) { d.erro = true; return d; }
        if (j && j.localidade) { d.cidade = j.localidade; d.uf = j.uf || d.uf; }
        return d;
      })
      .catch(function () { return d; })
      .then(function (r) { clearTimeout(t); return r; });
  }

  function lugar(d) { return d.cidade ? d.cidade + ' – ' + d.uf : d.uf; }
  /* 🔴 ACIMA DE 7 DIAS ÚTEIS O NÚMERO NÃO APARECE — [2026-09-30], ele: *"eu não quero o prazo
     de 34 dias úteis… isso aí espanta muito cliente"*. Escolheu "prazo calculado no checkout"
     (não travar em 7, que seria prometer o que a Yampi não cumpre). O preço continua. */
  var PRAZO_MAX = 7;
  /* [2026-10-12] `pre` = data da pré-venda (data-prevenda no Liquid: ficha com etiqueta `pre-venda`,
     ou gaveta com algum item dela) — a postagem vem antes do prazo de quem entrega */
  function prazoTxt(d, pre) {
    var t = d.dias > PRAZO_MAX ? 'prazo calculado no checkout'
      : d.dias ? 'chega em até ' + d.dias + (d.dias === 1 ? ' dia útil' : ' dias úteis') : 'frete e prazo calculados no checkout';
    return pre ? 'postagem a partir de ' + pre + ' · ' + t : t;
  }

  window.EttoreFrete = { faixa: faixa, destino: destino, lugar: lugar, prazo: prazoTxt };

  class GavetaEttore extends HTMLElement {
    constructor() {
      super();
      this.ocupada = false;
      this.gatilho = null;
      /* mensagem do cupom guardada entre um redesenho e outro */
      this.recado = null;
      /* o estado do cliente sobrevive à sessão: quem já disse o CEP não
         precisa dizer de novo a cada visita */
      /* 🔴 "SP" ERA UM CHUTE APRESENTADO COMO FATO — [2026-08-25].
         Ele perguntou: *"esse calcular frete já está sendo preenchido; é pra
         ele vir preenchido mesmo, ou só está de exemplo? Porque se for só de
         exemplo a gente matou o carro"*. Estava de exemplo.
         `localStorage.getItem('ettore-uf') || 'SP'` fazia TODO visitante novo
         ver "Chega entre 27 e 28 de agosto · SP" sem ter dito onde mora — uma
         data de entrega afirmada para quem pode estar em Manaus, onde o mesmo
         pedido leva o dobro.
         📏 Padrão silencioso vira promessa. Enquanto ninguém informa o CEP,
           o certo é não prometer data nenhuma. */
      /* [2026-09-30] guarda o DESTINO inteiro (`ettore-cep`), não só a UF: o prazo
         agora depende de capital × interior, que a UF não diz. Quem só tem o
         `ettore-uf` antigo digita o CEP de novo — prometer prazo sem ele seria
         o chute que a regra de 25/08 proíbe. */
      this.destino = null;
      try { this.destino = JSON.parse(localStorage.getItem('ettore-cep') || 'null'); } catch (e) {}
      if (this.destino && !this.destino.cep) this.destino = null;
      this.estado = this.destino ? this.destino.uf : '';
      this.addEventListener('click', this.aoClicar.bind(this));
      this.addEventListener('keydown', this.aoTeclar.bind(this));

      /* ⚠️ O BOTÃO "ADICIONAR" DOS CARDS NÃO FAZIA NADA. Medido em 16/08:
         17 botões `.pc-add` na home, e clicar deixava o carrinho em zero
         item. O botão era emitido pelo card desde sempre e NINGUÉM o
         escutava — nem a home, nem a categoria. É a décima primeira perda de
         portagem do projeto, e a mais cara: as outras estragavam a vitrine,
         esta impedia a compra.
         Ele escolheu o comportamento em 16/08: adicionou, a GAVETA ABRE.
         O ouvinte fica no documento (e não na gaveta) porque o botão vive
         fora dela, em qualquer seção, e card novo tem de nascer funcionando. */
      document.addEventListener('click', (e) => {
        var add = e.target.closest && e.target.closest('.pc-add');
        if (!add || add.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        this.adicionaDoCard(add);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.hasAttribute('data-aberta')) this.close();
      });
      this.pinta();
    }

    get cupons() {
      var mapa = {};
      (this.dataset.cupons || '').split(',').forEach(function (par) {
        var p = par.split(':');
        if (p.length === 2 && p[0].trim()) mapa[p[0].trim().toUpperCase()] = parseFloat(p[1]);
      });
      return mapa;
    }

    open(gatilho) {
      this.gatilho = gatilho || null;
      this.setAttribute('data-aberta', '');
      document.documentElement.style.overflow = 'hidden';
      var f = this.querySelector('.fechar');
      if (f) f.focus();
      this.confereConta();
    }

    /* 🔴 A REDE DE SEGURANÇA DO `open()` — [2026-08-24].
       Ele: *"os produtos não estão sendo adicionados direto ao carrinho
       quando clico em adicionar; depois, quando abro o carrinho, elas estão
       lá"*. A gaveta abria com o HTML que o Liquid desenhou no CARREGAMENTO
       da página — carrinho vazio — porque quem chamou `open()` não repintou
       antes.
       Corrigi o chamador (a página de produto), mas `open()` também é
       chamado por gente que não é minha: o `standard-actions-override.js`
       expõe `Shopify.actions.openCart` para QUALQUER app da loja abrir a
       gaveta. Consertar só os meus chamadores deixaria o defeito de pé pelo
       caminho que eu não controlo.
       📏 Por isso a verdade se confere aqui dentro: abre na hora (rápido) e
         compara o número desenhado com o `/cart.js` de verdade. Divergiu,
         repinta. Igual, não gasta nada além de um JSON pequeno. */
    confereConta() {
      var cab = this.querySelector('[data-conta]');
      if (!cab || this.ocupada) return;
      var desenhado = parseInt(cab.dataset.conta, 10);
      var eu = this;
      fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || typeof j.item_count !== 'number') return;
          if (j.item_count === desenhado) return;
          if (eu.ocupada) return;
          eu.redesenha();
        })
        .catch(function () { /* sem rede, o que está na tela é o que temos */ });
    }

    close() {
      this.removeAttribute('data-aberta');
      document.documentElement.style.overflow = '';
      if (this.gatilho && this.gatilho.focus) this.gatilho.focus();
    }

    aoTeclar(e) {
      /* [2026-09-20] O TAB FICA DENTRO DA GAVETA — auditoria 14/09: com `aria-modal` marcado, o teclado saía do painel e
         ia a controles encobertos pelo véu. Mesmo `ciclaTab` do menu (ettore-menu.liquid) e da busca (ettore-busca.js). */
      if (e.key === 'Tab' && this.hasAttribute('data-aberta')) {
        var cx = this.querySelector('.ett-gav-painel') || this;
        var f = Array.prototype.filter.call(cx.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) { return el.getClientRects().length > 0; });
        if (!f.length) { e.preventDefault(); return; }
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
        return;
      }
      if (e.key !== 'Enter') return;
      if (e.target.hasAttribute('data-cup-in')) { e.preventDefault(); this.aplicaCupom(); }
      if (e.target.hasAttribute('data-cep')) { e.preventDefault(); this.calculaCep(); }
    }

    aoClicar(e) {
      var alvo = e.target;
      if (alvo.closest('[data-fecha-gaveta]') || alvo.closest('.fechar')) return this.close();

      var qtd = alvo.closest('[data-qtd]');
      if (qtd) {
        var linha = parseInt(qtd.dataset.qtd, 10);
        var caixa = qtd.parentNode.querySelector('.qv');
        var atual = parseInt(caixa.textContent, 10);
        var passo = parseInt(qtd.dataset.d, 10);
        var nova = atual + passo;
        if (nova < 1 || nova > 9) return;
        /* 🔴 A RESPOSTA TEM DE SER NA HORA — [2026-09-08], ele: *"ficou confuso
           quando adiciona mais uma quantidade pelo carrinho, ele não mostra que
           foi adicionado"*.
           📏 Medido antes: do clique até o número mudar passavam ~1.000 ms, e
             nesse intervalo o número, o total e o contador ficavam TODOS parados
             enquanto a gaveta desbotava para 55%. Para quem clica, o botão não
             fez nada — ou a gaveta desligou.
           👉 A soma o navegador já sabe fazer: o número e o contador mudam agora,
             e o servidor confirma no `redesenha()`. Se ele recusar (estoque), o
             redesenho traz o valor certo e desfaz — que é o comportamento correto
             de uma atualização otimista.
           🪤 NÃO dá para atualizar o preço da linha aqui: aquele número é o preço
             POR UNIDADE (`item.final_price`), não o da linha — ele não muda com a
             quantidade e mexer nele seria inventar. Quem muda é o TOTAL, e esse
             o redesenho traz. */
        caixa.textContent = nova;
        /* o preço do CARTÃO é o da linha, então ele muda junto com o número —
           a conta sai de `data-unit`, em centavos, posta pelo Liquid */
        var pr = qtd.closest('.pe') ? qtd.closest('.pe').querySelector('.pr') : null;
        if (pr && pr.dataset.unit) {
          var un = parseInt(pr.dataset.unit, 10) || 0;
          var alvoTot = pr.querySelector('[data-pr-tot]');
          if (alvoTot) alvoTot.textContent = br(un * nova);
          var alvoDe = pr.querySelector('[data-pr-de]');
          if (alvoDe && pr.dataset.unitDe) alvoDe.textContent = br((parseInt(pr.dataset.unitDe, 10) || 0) * nova);
          var alvoUn = pr.querySelector('[data-pr-un]');
          if (alvoUn) { alvoUn.textContent = nova + ' × ' + br(un); alvoUn.hidden = nova < 2; }
        }
        var cabCaixa = this.querySelector('.gcab');
        var cabTit = this.querySelector('.gcab h2');
        if (cabCaixa && cabTit) {
          var n = (parseInt(cabCaixa.dataset.conta, 10) || 0) + passo;
          cabCaixa.dataset.conta = n;
          cabTit.textContent = 'Seu carrinho' + (n > 0 ? ' · ' + n + (n === 1 ? ' item' : ' itens') : '');
        }
        return this.mudaLinha(linha, nova);
      }

      var rem = alvo.closest('[data-rem]');
      if (rem) return this.mudaLinha(parseInt(rem.dataset.rem, 10), 0);

      var up = alvo.closest('[data-up]');
      if (up) return this.adiciona(up.dataset.up, up);

      if (alvo.closest('[data-cup-abre]')) return this.abreCupom();
      if (alvo.closest('[data-cup-bt]')) return this.aplicaCupom();
      if (alvo.closest('[data-troca-cep]')) return this.abreCep();
      if (alvo.closest('[data-cep-bt]')) return this.calculaCep();
      if (alvo.closest('[data-checkout]')) return this.finaliza();
    }

    /* ---- conversa com a API de carrinho ---- */

    trava(v) {
      this.ocupada = v;
      if (v) this.setAttribute('data-ocupada', '');
      else this.removeAttribute('data-ocupada');
    }

    /* 🔴 A GAVETA ENGOLIA ERRO DA API — [2026-09-13], pontos 06 e 07 da auditoria do Codex,
       confirmados no código: `fetch` NÃO rejeita em 422/500, então mudar quantidade, adicionar e
       guardar cupom passavam direto ao redesenho como se tivessem dado certo; e uma queda de
       rede no meio do cupom deixava `ocupada=true` para sempre — gaveta travada. Agora todo
       caminho confere `r.ok`, e quem falha cai aqui: solta a trava e escreve o motivo na
       própria gaveta, SEM redesenhar (redesenhar numa rede caída seria tentar de novo o que
       acabou de falhar). O aviso some no próximo redesenho, que troca o painel inteiro. */
    falha(texto) {
      this.trava(false);
      var painel = this.querySelector('.ett-gav-painel');
      if (!painel) return;
      var el = painel.querySelector('[data-gav-erro]');
      if (!el) {
        el = document.createElement('p');
        el.className = 'cupmsg erro';
        el.setAttribute('data-gav-erro', '');
        el.setAttribute('role', 'alert');
        painel.insertBefore(el, painel.firstChild);
      }
      el.textContent = texto;
    }

    mudaLinha(linha, quantidade) {
      if (this.ocupada) return;
      this.trava(true);
      fetch(raiz + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: linha, quantity: quantidade })
      })
        .then((r) => { if (!r.ok) throw new Error('recusado'); return this.redesenha(); })
        .catch(() => this.falha('Não deu para mudar a quantidade. Tente de novo.'));
    }

    adiciona(varianteId, botao) {
      if (this.ocupada) return;
      this.trava(true);
      if (botao) botao.textContent = 'ADICIONANDO…';
      fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(varianteId), quantity: 1 }] })
      })
        .then((r) => { if (!r.ok) throw new Error(r.status === 422 ? 'esgotada' : 'recusado'); return this.redesenha(); })
        .catch((err) => {
          if (botao) botao.textContent = 'ADICIONAR';
          this.falha(err && err.message === 'esgotada' ? 'Essa peça acabou de esgotar.' : 'Não deu para adicionar. Tente de novo.');
        });
    }

    /* Adicionar a partir de um card, em qualquer tela, e ABRIR A GAVETA.
       É o que ele chamou de "carrinho flutuante, estilo marca grande": a
       venda continua na mesma tela, com a barra de frete grátis dizendo
       quanto falta — em vez de jogar a pessoa numa página de carrinho. */
    adicionaDoCard(botao) {
      if (this.ocupada) return;
      var variante = botao.dataset.variante;
      if (!variante) return;
      var rotulo = botao.textContent;
      this.trava(true);
      botao.textContent = 'Adicionando…';
      fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        /* [2026-10-19] `data-junto`: o cartão da 2ª Luminária Sem Fio mostra o preço do PAR, então o Comprar leva o par
           (a Pisa da mesma cor + a 2ª). Sem isso o cartão dizia R$ 629 e o carrinho recebia R$ 270. */
        body: JSON.stringify({ items: (botao.dataset.junto ? [{ id: Number(botao.dataset.junto), quantity: 1 }] : []).concat([{ id: Number(variante), quantity: 1 }]) })
      })
        .then((r) => {
          /* 🔴 ERRO DE REDE VIRAVA "ESGOTADA" — [2026-09-13], ponto 05 da auditoria do Codex,
             reproduzido com um 500 simulado: o botão dizia "Esgotada" e ficava desabilitado por
             uma queda de rede — informação falsa sobre estoque, e a venda morria ali. Só o 422 da
             Shopify (sem estoque) é esgotamento; o resto é "tente de novo", com o botão vivo. */
          if (!r.ok) throw new Error(r.status === 422 ? 'esgotada' : 'recusado');
          return this.redesenha();
        })
        .then(() => {
          botao.textContent = rotulo;
          this.open(botao);
        })
        .catch((err) => {
          this.trava(false);
          if (err && err.message === 'esgotada') {
            /* Peça que acabou entre a página carregar e o clique cai aqui. Dizer
               "Esgotada" é mais honesto que um botão que pisca e não faz nada. */
            botao.textContent = 'Esgotada';
            botao.disabled = true;
            return;
          }
          botao.textContent = 'Tente de novo';
          setTimeout(() => { botao.textContent = rotulo; }, 2500);
        });
    }

    /* O cupom mora nos ATRIBUTOS do carrinho, não no navegador: assim ele
       sobrevive ao recarregar, vale em qualquer aba, e o Liquid já desenha a
       gaveta com ele — sem piscar o preço sem desconto antes. */
    guardaCupom(codigo, pct) {
      return fetch(raiz + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { cupom: codigo || '', cupom_pct: pct ? String(pct) : '' } })
      }).then((r) => { if (!r.ok) throw new Error('recusado'); return r; });
    }

    /* 🔑 CÓDIGO FORA DA LISTA SE PERGUNTA À SHOPIFY — [2026-09-30], ordem dele:
       *"todos os cupons que tiverem ativo na Shopify é para aplicar no carrinho"*.
       A gaveta só conhecia o cupom da oferta vigente e recusava GANHOU20, ativo
       na loja. Aplica o código no carrinho da Shopify, lê se ela aceitou e quanto
       tirou, e TIRA DE NOVO: o desconto fica só no atributo, como o CASANOVA.
       🪤 Deixar o desconto no carrinho daria DOIS descontos: o `data-total` do
         resumo já viria abatido e a gaveta abateria o % por cima.
       📏 Medido no ar (Bailarina 309,00): GANHOU20 aplicável, 247,20;
         NAOEXISTE123 `applicable:false`. A Yampi dá os mesmos 247,20.
       ⚠️ Cupom de VALOR FIXO vira o % do carrinho no momento da validação. */
    /* 🔴 CUPOM DA SHOPIFY SE CONFERE DE NOVO QUANDO O CARRINHO MUDA — [2026-09-30]. QUEROCOMBO só vale com 2+
       peças: aplicado com duas e tirada uma, a gaveta seguia mostrando −20% que o checkout não dá. Só para o
       código que veio da Shopify (`data-cupom-extra`); o da oferta vigente segue pela lista. Uma conferência por
       (código, total): o `pinta()` roda a cada redesenho e não pode virar laço. Cupom de valor fixo ganha o %
       novo pelo mesmo caminho. */
    revalidaCupom(cod, pago) {
      if (!cod || this.dataset.cupomExtra !== cod || this.ocupada) return;
      var chave = cod + '|' + pago;
      if (this._cupomConferido === chave) return;
      this._cupomConferido = chave;
      var pctAtual = this.cupons[cod];
      this.validaNaShopify(cod).then((pct) => {
        if (pct === null) {
          this.recado = { classe: 'cupmsg erro', texto: 'O cupom ' + cod + ' não vale para este carrinho.', manterCampo: cod };
          return this.guardaCupom('').then(() => this.redesenha());
        }
        if (Math.abs(pct - pctAtual) > 0.01) return this.guardaCupom(cod, pct).then(() => this.redesenha());
      }).catch(() => {});
    }

    validaNaShopify(cod) {
      var manda = (d) => fetch(raiz + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: d })
      }).then((r) => { if (!r.ok) throw new Error('recusado'); return r.json(); });
      return manda(cod).then((c) => {
        var ok = (c.discount_codes || []).some((d) => (d.code || '').toUpperCase() === cod && d.applicable);
        var cheio = c.original_total_price || 0;
        var pct = ok && cheio ? Math.round((cheio - c.total_price) / cheio * 10000) / 100 : 0;
        return manda('').then(() => (ok ? pct : null));
      });
    }

    /* Redesenha pelo Liquid, não à mão. Recalcular os totais no JS seria
       manter duas contas vivas — e uma delas ia divergir da outra num dia de
       promoção. Quem soma é sempre a Shopify. */
    redesenha() {
      var secao = this.dataset.secao;
      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(secao))
        .then((r) => r.json())
        .then((j) => {
          var html = j[secao];
          if (!html) throw new Error('seção não voltou');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var novo = doc.querySelector('.ett-gav-painel');
          var atual = this.querySelector('.ett-gav-painel');
          /* [2026-09-20] O FOCO SOBREVIVE AO REDESENHO — auditoria 14/09: trocar o innerHTML inteiro jogava o foco do
             teclado para o início da página a cada +/−, cupom ou remoção. Guardo o elemento focado por um seletor de
             atributos data-* (o mais estável que o painel tem) e a posição entre iguais, e refoco o equivalente. */
          var lembra = null, ativo = document.activeElement;
          if (atual && ativo && atual.contains(ativo)) {
            var attrs = Array.prototype.filter.call(ativo.attributes, function (a) { return a.name.indexOf('data-') === 0; })
              .map(function (a) { return '[' + a.name + (a.value ? '="' + a.value.replace(/"/g, '\\"') + '"' : '') + ']'; }).join('');
            var sel = ativo.tagName.toLowerCase() + attrs;
            try { lembra = { sel: sel, i: Array.prototype.indexOf.call(atual.querySelectorAll(sel), ativo) }; } catch (_) { lembra = null; }
          }
          if (novo && atual) atual.innerHTML = novo.innerHTML;
          /* [2026-09-30] A LISTA DE CUPONS MORA NO <cart-drawer>, FORA DO PAINEL — o redesenho só troca o painel, então
             o cupom validado na Shopify (que o Liquid acrescenta à lista) nunca chegava: medido no ar, `cupom_pct: 20`
             gravado e `data-cupons` parado em "CASANOVA:15". Copiar a lista junto. */
          var gNova = doc.querySelector('cart-drawer');
          if (gNova && gNova.hasAttribute('data-cupons')) this.dataset.cupons = gNova.dataset.cupons;
          if (gNova) this.dataset.cupomExtra = gNova.dataset.cupomExtra || '';
          if (lembra && atual) {
            var de = atual.querySelectorAll(lembra.sel), alvo = de[lembra.i] || de[0] || this.querySelector('.fechar');
            if (alvo && alvo.focus) alvo.focus();
          }
          this.trava(false);
          this.pinta();
          /* o contador da sacola no cabeçalho escuta este evento */
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(() => {
          /* Se o redesenho falhar, o carrinho JÁ MUDOU no servidor e a tela
             estaria mentindo. Recarregar é feio, mas mostra a verdade. */
          window.location.reload();
        });
    }

    /* ---- cupom ---- */

    abreCupom() {
      var f = this.querySelector('[data-cup-form]');
      var bt = this.querySelector('[data-cup-abre]');
      if (!f) return;
      var abre = f.hidden;
      f.hidden = !abre;
      if (bt) bt.setAttribute('aria-expanded', String(abre));
      if (abre) f.querySelector('[data-cup-in]').focus();
    }

    aplicaCupom() {
      if (this.ocupada) return;
      var campo = this.querySelector('[data-cup-in]');
      var msg = this.querySelector('[data-cup-msg]');
      if (!campo || !msg) return;
      var cod = (campo.value || '').trim().toUpperCase();
      var tabela = this.cupons;

      /* ⚠️ O RECADO TEM DE SOBREVIVER AO REDESENHO. Escrever na tela aqui não
         adianta: logo abaixo vem o redesenho, que troca o HTML inteiro e leva
         a mensagem junto. Foi assim que quem digitava cupom errado não recebia
         resposta nenhuma — o oposto do "resposta na hora" que a gaveta
         prometia. Guardado aqui, é `pinta()` quem o reescreve no fim. */
      var caiu = () => this.falha('Não deu para salvar o cupom. Confira a conexão e tente de novo.');
      if (!cod) {
        this.recado = null;
        this.trava(true);
        return this.guardaCupom('').then(() => this.redesenha()).catch(caiu);
      }
      if (tabela[cod] === undefined) {
        this.trava(true);
        return this.validaNaShopify(cod).then((pct) => {
          if (pct === null) {
            this.recado = {
              classe: 'cupmsg erro',
              texto: 'Não reconhecemos esse código. Você ainda pode tentar no checkout.',
              manterCampo: cod
            };
            return this.guardaCupom('');
          }
          this.recado = null;
          return this.guardaCupom(cod, pct);
        }).then(() => this.redesenha()).catch(caiu);
      }
      /* 🔴 O RECADO DE SUCESSO SAIU — [2026-09-08], ordem dele: *"quando aplicado
         aparecer só uma vez, e lá embaixo"*. Ele já tinha encurtado esta frase em
         24/08 pelo mesmo motivo (*"lá embaixo já fala o cupom e o valor do
         desconto"*); agora ela sai inteira. Quem confirma o gesto é a linha
         `Cupom CASANOVA − R$ 122,55` do resumo, que nasce no mesmo instante, mais
         o total caindo. O recado de ERRO continua — lá não há nada embaixo que
         diga que o código foi recusado.
         🪤 Este texto vivia em DOIS lugares deste arquivo; o outro, no `pinta()`,
           saiu junto. Se um dia voltar, volte nos dois. */
      this.recado = null;
      this.trava(true);
      this.guardaCupom(cod).then(() => this.redesenha()).catch(caiu);
    }

    /* ---- CEP e prazo ---- */

    abreCep() {
      var cx = this.querySelector('[data-przcep]');
      var bt = this.querySelector('[data-troca-cep]');
      if (!cx || !bt) return;
      var abre = cx.hidden;
      cx.hidden = !abre;
      bt.setAttribute('aria-expanded', String(abre));
      bt.textContent = abre ? 'fechar' : 'trocar CEP';
      if (abre) cx.querySelector('[data-cep]').focus();
    }

    calculaCep() {
      var campo = this.querySelector('[data-cep]');
      var sub = this.querySelector('[data-przSub]');
      if (!campo || !sub) return;
      var cep = (campo.value || '').replace(/\D/g, '');
      if (cep.length !== 8) {
        sub.textContent = 'Digite os 8 números do CEP.';
        return;
      }
      sub.textContent = 'Consultando o CEP…';
      destino(cep).then((d) => {
        if (d.erro) {
          sub.textContent = 'CEP não encontrado. Confira os oito dígitos.';
          return;
        }
        this.destino = d;
        this.estado = d.uf;
        try { localStorage.setItem('ettore-cep', JSON.stringify(d)); } catch (e) {}
        /* respondeu: o campo se recolhe e o botão volta a ser "trocar CEP".
           Deixar o teclado aberto sobre a resposta é esconder o que ele
           acabou de pedir. */
        var cx = this.querySelector('[data-przcep]');
        var bt = this.querySelector('[data-troca-cep]');
        if (cx) { cx.hidden = true; }
        if (bt) { bt.setAttribute('aria-expanded', 'false'); bt.textContent = 'trocar CEP'; }
        this.pinta();
      });
    }

    /* ---- o que só o navegador sabe: frete estimado, Pix, parcela, prazo ---- */

    pinta() {
      var resumo = this.querySelector('.resumo');
      var przTit = this.querySelector('[data-przTit]');
      var przSub = this.querySelector('[data-przSub]');
      var pv = this.querySelector('[data-prevenda]'); // pré-venda no carrinho (ettore-gaveta.liquid)
      var campoCep = this.querySelector('[data-cep]');

      if (campoCep && !campoCep.dataset.ligado) {
        campoCep.dataset.ligado = '1';
        campoCep.addEventListener('input', function () {
          var v = this.value.replace(/\D/g, '').slice(0, 8);
          this.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
        });
      }

      /* sem CEP conhecido não há prazo a mostrar: o bloco vira só o convite
         de calcular, que é o que ele pediu ao querer a linha fechada */
      if (przTit) {
        przTit.textContent = this.destino
          ? prazoTxt(this.destino, pv && pv.dataset.prevenda).replace(/^./, function (c) { return c.toUpperCase(); })
          : 'Informe o seu CEP para ver o prazo';
      }
      var przCep = this.querySelector('[data-przcep]');
      if (przCep && !this.destino) { przCep.hidden = false; }
      var btTroca = this.querySelector('[data-troca-cep]');
      if (btTroca) { btTroca.hidden = !this.destino; }
      /* o redesenho traz a linha fechada de novo (é o padrão do Liquid);
         se ela estava aberta, reabre — senão fecha na cara de quem abriu */
      if (this.freteAberto) {
        var przAbre = this.querySelector('[data-prz-abre]');
        var przCx = this.querySelector('[data-prz-cx]');
        if (przAbre && przCx) { przCx.hidden = false; przAbre.setAttribute('aria-expanded', 'true'); }
      }
      if (!resumo) return;

      var pago = parseInt(resumo.dataset.total, 10) || 0;
      var limite = parseInt(this.dataset.limite, 10) || 49900;
      var tabela = this.cupons;

      /* o recado guardado antes do redesenho volta à tela aqui — e, quando o
         código foi recusado, ele fica no campo para a pessoa poder corrigir
         em vez de digitar tudo de novo */
      var msgEl = this.querySelector('[data-cup-msg]');
      if (this.recado && msgEl) {
        msgEl.className = this.recado.classe;
        msgEl.textContent = this.recado.texto;
        var form = this.querySelector('[data-cup-form]');
        if (form) form.hidden = false;
        var abre = this.querySelector('[data-cup-abre]');
        if (abre) abre.setAttribute('aria-expanded', 'true');
        if (this.recado.manterCampo) {
          var c = this.querySelector('[data-cup-in]');
          if (c) c.value = this.recado.manterCampo;
        }
      }

      var campoCup = this.querySelector('[data-cup-in]');
      var cod = campoCup ? (campoCup.value || '').trim().toUpperCase() : '';
      var pct = tabela[cod];
      this.revalidaCupom(cod, pago);
      var descCup = pct ? Math.round(pago * pct / 100) : 0;
      var comCupom = pago - descCup;

      var linCup = this.querySelector('[data-lin-cup]');
      if (linCup) {
        if (descCup > 0) {
          linCup.classList.remove('oculto');
          this.querySelector('[data-lin-cup-nome]').textContent = 'Cupom ' + cod;
          this.querySelector('[data-lin-cup-val]').textContent = '− ' + br(descCup);
        } else {
          linCup.classList.add('oculto');
        }
      }

      /* ⚠️ A RÉGUA DO FRETE GRÁTIS É O VALOR ANTES DO CUPOM, e isto é decisão
         de negócio, não detalhe. Medindo com o valor já descontado, aplicar
         CASANOVA fazia a barra ANDAR PARA TRÁS — de "faltam R$ 457,00" para
         "faltam R$ 463,30" — bem no momento em que a pessoa acabou de ganhar
         um desconto. A oferta dele diz "frete grátis acima de R$ 499", e o
         que a pessoa comprou são os R$ 499, não o que sobrou depois do cupom.
         ⚠️ A CONFIRMAR COM O YAMPI: se lá a régua for o valor pós-cupom, a
         gaveta promete frete grátis que o checkout não dá. Só um pedido de
         teste real responde. */
      /* 🔴 SEM ESTADO CONHECIDO, O FRETE NÃO ENTRA NO TOTAL — [2026-09-01].
         Antes, `indexOf(undefined)` dava −1 e a gaveta somava R$ 19,90 — o
         frete MAIS CARO — a quem nunca disse onde mora: o Cogumelo de R$ 319
         virava "Total R$ 338,90" aqui e "R$ 319,00" no checkout. O preço
         subia na gaveta e descia no Yampi. É a mesma família da armadilha do
         'SP' silencioso: sem dado, não prometer — convidar a informar. */
      /* [2026-09-30] o valor sai da tabela Frete Fixo; CEP num buraco da tabela
         conta como "não sei" — o checkout calcula, a gaveta não soma nada. */
      var sabeEstado = !!(this.destino && this.destino.preco);
      var frete = 0;
      if (pago < limite && sabeEstado) frete = this.destino.preco;

      var fn = this.querySelector('[data-frete-nome]');
      var fv = this.querySelector('[data-frete-val]');
      /* 🪤 [2026-09-08] A CLASSE `gratis` NA LINHA DO FRETE. O CSS do celular
         esconde a linha só quando ela tem essa classe — porque a faixa verde do
         topo já anuncia o frete grátis, e repetir era o motivo de a regra de
         agosto escondê-la. Quando a pessoa PAGA, ou ainda não disse o CEP, a
         linha aparece: foi o pedido dele de hoje ("preciso comunicar quanto ela
         tá pagando de frete"). Sem esta linha de código o CSS não tem como saber. */
      var linFrete = fn ? fn.closest('.lin') : null;
      if (linFrete) linFrete.classList.toggle('gratis', pago >= limite);
      if (fn && fv) {
        if (pago >= limite) {
          fn.textContent = 'Frete';
          fv.textContent = 'Grátis';
          fv.style.color = 'var(--verde)';
          fv.style.fontWeight = '640';
        } else if (!sabeEstado) {
          fn.textContent = 'Frete';
          fv.textContent = this.destino ? 'no checkout' : 'calcule pelo CEP';
          fv.style.color = '';
          fv.style.fontWeight = '';
        } else {
          fn.textContent = 'Frete · ' + this.estado;
          fv.textContent = br(frete);
          fv.style.color = '';
          fv.style.fontWeight = '';
        }
      }

      var total = comCupom + frete;
      var escreve = (sel, txt) => { var e = this.querySelector(sel); if (e) e.textContent = txt; };
      escreve('[data-tot]', br(total));
      escreve('[data-bt-tot]', br(total));
      escreve('[data-pixv]', br(Math.round(total * 0.95)));
      escreve('[data-parcv]', '4x de ' + br(Math.round(total / 4)));
      escreve('[data-cash]', br(Math.round(comCupom * 0.10)));

      /* ═══ A ECONOMIA SOMA A PEÇA E O CUPOM — [2026-09-08], ordem dele ═══════
         *"na linha de desconto acho que pode aplicar o cupom junto"*. Antes eram
         duas linhas separadas (o "Você economizou" do riscado e a do cupom) e
         ninguém somava as duas. Agora a linha verde embaixo do total diz o ganho
         inteiro: (cheio − pago) + o cupom.
         🪤 A linha do CUPOM continua na conta, acima do total, porque ela mexe no
           total de verdade. A economia é resumo, não subtração — por isso fica
           DEPOIS do total, e por isso a conta na tela continua fechando. */
      var rz = this.querySelector('.resumo');
      var cheio = rz ? (+rz.dataset.cheio || 0) : 0;
      var economia = (cheio > pago ? cheio - pago : 0) + descCup;
      var linEcon = this.querySelector('[data-lin-econ]');
      if (linEcon) {
        linEcon.classList.toggle('oculto', economia <= 0);
        escreve('[data-econ-val]', br(economia));
      }

      /* a barra e a frase seguem a mesma régua da linha de frete: valor da
         compra, antes do cupom — senão as duas se contradiriam na mesma tela */
      var falta = limite - pago;
      var barra = this.querySelector('[data-fbarra]');
      var txt = this.querySelector('[data-ftxt]');
      var alvo = this.querySelector('[data-falvo]');
      if (barra) barra.style.transform = 'scaleX(' + (falta <= 0 ? 1 : Math.max(0.04, pago / limite)) + ')';
      if (txt) {
        txt.innerHTML = falta <= 0
          ? '<b>Frete grátis liberado.</b>'
          : 'Faltam <b>' + br(falta) + '</b> para o frete grátis.';
      }
      if (alvo) alvo.classList.toggle('chegou', falta <= 0);

      /* 🔴 O FRETE SAIU DAQUI DE VEZ — [2026-08-25]. Ele contou: *"o escrito
         frete grátis está 3 vezes no carrinho, acho que tem que ter apenas 2,
         acho que sai o da calculadora"*. Estava certo, e medido:
             y60   "Você ganhou frete grátis!"   (a barra de progresso)
             y303  "frete grátis"                (AQUI, na linha do CEP)
             y620  "Grátis"                      (a linha do resumo)
         O comentário anterior já dizia "em linha própria ele repetia a barra
         do topo e a linha do resumo — a mesma informação três vezes", e a
         solução de então foi encostá-lo na linha da cidade. Encostar não é
         tirar: continuava sendo a terceira.
         📏 Quando a resposta a uma repetição é MOVER, ela volta. A barra do
           topo diz que ganhou; o resumo diz quanto é. Esta linha diz de onde
           sai e quando chega — que é o que ninguém mais diz. */
      if (przSub) { przSub.textContent = this.destino ? lugar(this.destino) : ''; }
    }

    /* ---- checkout ----
       ⚠️ /cart, nunca /checkout: medido em 15/08, o checkout nativo da
       Shopify PULA O YAMPI. Quem redireciona para seguro.ettoredecor.com.br
       é a rota /cart. */
    finaliza() {
      var campo = this.querySelector('[data-cup-in]');
      var cod = campo ? (campo.value || '').trim().toUpperCase() : '';
      var url = raiz + 'cart';
      if (cod && this.cupons[cod] !== undefined) url += '?promocode=' + encodeURIComponent(cod);
      window.location.href = url;
    }
  }

  customElements.define('cart-drawer', GavetaEttore);
})();


/* ═══ AS SETAS DA SUGESTÃO — [2026-08-25] ═══════════════════════════════════
   Um cartão por vez pede um jeito de passar. `scrollBy` da largura do trilho,
   com o `scroll-snap` do CSS fazendo o encaixe.
   🪤 AS SETAS FICAM DESABILITADAS NA PONTA, não escondidas — a lição das setas
     de categoria em 17/08: escondendo, a que sobra escorrega para o outro
     canto e o alvo muda de lugar debaixo da mão.
   🔴 E ESTE BLOCO VIVE FORA DA CLASSE, no fim do arquivo, de propósito.
     Eu o escrevi primeiro DENTRO do corpo da classe da gaveta, e uma função
     autoexecutável ali não é sintaxe válida: `SyntaxError: Unexpected token
     '('`. O arquivo inteiro parou de compilar, e o sintoma NÃO foi a seta sem
     funcionar — foi o Pix e o cashback ficarem VAZIOS no resumo, porque quem
     os calcula é este mesmo arquivo. Só vi olhando o print.
     📏 JS que quebra derruba o arquivo TODO, não só a linha errada. E o
       sintoma aparece longe do erro. */
/* ═══ A LINHA DE FRETE QUE ABRE — [2026-08-25] ═══════════════════════════════
   Mesmo gesto do cupom, a pedido dele. Uma linha, um clique, o conteúdo
   aparece — e o `aria-expanded` acompanha, senão o leitor de tela anuncia o
   conteúdo escondido como se estivesse na tela. */
/* 🔴 E ELE PAROU DE ABRIR — [2026-08-24]. Ele: *"só um problema no
   carrinho: quando clico em calcular frete, não está abrindo"*.
   Era exatamente o defeito das setas, que está escrito na função LOGO
   ABAIXO desta, no mesmo arquivo, no mesmo dia: o ouvinte estava preso ao
   BOTÃO, e a gaveta se redesenha inteira a cada mudança no carrinho —
   levando o botão antigo, e o ouvinte junto. Piorou hoje porque o
   `open()` passou a repintar sozinho quando a conta diverge, então o
   botão morria já na primeira abertura.
   📏 Escrever o aviso ao lado não é aplicá-lo. Neste arquivo, ouvinte
     preso a elemento é sempre defeito: delegar no `document`, sempre. */
(function freteQueAbre() {
  document.addEventListener('click', function (ev) {
    var bt = ev.target.closest ? ev.target.closest('.ett-gav [data-prz-abre]') : null;
    if (!bt) return;
    var cx = bt.closest('.prazo') && bt.closest('.prazo').querySelector('[data-prz-cx]');
    if (!cx) return;
    var aberto = bt.getAttribute('aria-expanded') === 'true';
    bt.setAttribute('aria-expanded', aberto ? 'false' : 'true');
    cx.hidden = aberto;
    /* a gaveta guarda o estado: sem isto, mexer na quantidade repinta e
       fecha o frete na cara de quem tinha acabado de abrir */
    var gav = bt.closest('.ett-gav');
    if (gav) gav.freteAberto = !aberto;
  });
})();

(function setasDaSugestao() {
  /* 🔴 AS SETAS PARAVAM DE FUNCIONAR E EU NÃO TINHA VISTO — [2026-08-25].
     Ele: *"o carrossel não funciona, não passa para o lado; só quando eu
     adiciono o produto é que aparece um produto novo"*.
     Medido: o trilho ROLA (scrollBy leva de 0 a 386, com 1921 de conteúdo).
     O que não funcionava era o CLIQUE — a gaveta se redesenha inteira a cada
     mudança no carrinho, e os ouvintes presos aos botões antigos morrem com
     eles. Por isso "só aparece produto novo quando adiciono": o re-render
     trocava o conteúdo, e nunca a seta.
     📏 Em interface que se redesenha, ouvinte preso ao ELEMENTO morre no
       primeiro redesenho. Delegação no `document` sobrevive a todos. */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest ? ev.target.closest('.ett-gav [data-gups]') : null;
    if (!b) return;
    var tr = b.closest('.gups') && b.closest('.gups').querySelector('.gups-tr');
    if (!tr) return;
    tr.scrollBy({ left: tr.clientWidth * (+b.dataset.gups), behavior: 'smooth' });
  });
  /* a marcação de ponta também precisa sobreviver ao redesenho */
  document.addEventListener('scroll', function (ev) {
    var tr = ev.target;
    if (!tr || !tr.classList || !tr.classList.contains('gups-tr')) return;
    var cx = tr.closest('.gups'); if (!cx) return;
    var fim = tr.scrollWidth - tr.clientWidth - 2;
    cx.querySelectorAll('[data-gups]').forEach(function (b) {
      b.disabled = (+b.dataset.gups < 0) ? tr.scrollLeft <= 2 : tr.scrollLeft >= fim;
    });
  }, { capture: true, passive: true });   /* [2026-09-12] passivo: nunca chama preventDefault */
})();
